import { RootState } from '@/store/types';
import { ActionTree, GetterTree, Module, MutationTree } from 'vuex';
import { MessageAccueilCms } from './types';
import { getMessageAccueilCms } from '@/services/api/cms/messageAccueil/api';
import _ from 'lodash';

const namespaced = true;

export const state: MessageAccueilCms = {
	message: null,
	errorCode: null
};

export const mutations: MutationTree<MessageAccueilCms> = {
	mutateMessageAccueilCms(state: MessageAccueilCms, message: string | null): void {
		state.message = message;
	},
	mutateErrorCodeCms(state: MessageAccueilCms, errorCode: string | null): void {
		state.errorCode = errorCode;
	}
};

export const actions: ActionTree<MessageAccueilCms, RootState> = {
	fetchMessageAccueilFromCms(state): Promise<void> {
		return new Promise((resolve, reject) => {
			return getMessageAccueilCms()
				.then((response: any) => {
					const message = _.get(response, 'data.value.message');
					const errorCode = _.get(response, 'data.value.errorCode');

					state.commit('mutateMessageAccueilCms', message);
					state.commit('mutateErrorCodeCms', errorCode);
					resolve();
				})
				.catch((error: any) => {
					state.commit('mutateMessageAccueilCms', '');
					state.commit('mutateErrorCodeCms', 'CMS KO');
					reject();
				});
		});
	}
};

export const getters: GetterTree<MessageAccueilCms, RootState> = {
	getMessageAccueilFromCms(state): MessageAccueilCms {
		const formatedMessage: MessageAccueilCms = {
			message: state.message,
			errorCode: state.errorCode
		};
		return formatedMessage;
	}
};

export const messageAccueilCms: Module<MessageAccueilCms, RootState> = {
	namespaced,
	state,
	actions,
	getters,
	mutations
};
